import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';

class ModalComponent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string.isRequired,
    colored: PropTypes.bool,
    header: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    modal: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: '',
    message: '',
    colored: false,
    header: false,
    onConfirm: null,
  };

  render() {
    const {
      color,
      title,
      message,
      colored,
      header,
      toggle,
      modal,
      onConfirm,
      t,
    } = this.props;
    // const { modal } = this.state;
    let Icon;

    switch (color) {
      case 'primary':
        Icon = <span className="lnr lnr-pushpin modal__title-icon" />;
        break;
      case 'success':
        Icon = <span className="lnr lnr-thumbs-up modal__title-icon" />;
        break;
      case 'warning':
        Icon = <span className="lnr lnr-flag modal__title-icon" />;
        break;
      case 'danger':
        Icon = <span className="lnr lnr-cross-circle modal__title-icon" />;
        break;
      default:
        break;
    }
    const modalClass = classNames({
      'modal-dialog--colored': colored,
      'modal-dialog--header': header,
    });

    return (
      <div>
        <Modal
          isOpen={modal}
          toggle={toggle}
          className={`modal-dialog--${color} ${modalClass} modal-alert`}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggle}
            />
            {header ? '' : Icon}
            <h4 className="bold-text  modal__title">{title}</h4>
          </div>
          <div className="modal__body">{message}</div>
          {onConfirm ? (
            <ButtonToolbar className="modal__footer">
              <Button color="danger" onClick={toggle}>
                {t('general.cancel')}
              </Button>
              <Button outline={colored} color="success" onClick={onConfirm}>
                {t('general.confirm')}
              </Button>
            </ButtonToolbar>
          ) : null}
        </Modal>
      </div>
    );
  }
}

export default withTranslation('common')(ModalComponent);
